import { render } from "./SpecialPageCarousel.vue?vue&type=template&id=1e87a763&scoped=true&ts=true"
import script from "./SpecialPageCarousel.vue?vue&type=script&lang=ts"
export * from "./SpecialPageCarousel.vue?vue&type=script&lang=ts"

import "./SpecialPageCarousel.vue?vue&type=style&index=0&id=1e87a763&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e87a763"]])

export default __exports__